const createEditable = require('../../adapters/createEditable');
const { getCarouselProps } = require('./utils');

const renderMe = props => props.children.length > 0;
const renderWrapper = renderMe;
const renderBase = renderMe;

module.exports = Base => createEditable(Base, getCarouselProps, renderWrapper, renderBase);
